import { Component } from '@angular/core';
import { ProductStatusDashboardService } from './product-status-dashboard.service';
import { FormsModule } from '@angular/forms';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToastMessageService } from 'src/app/toastr.service';
import { LogmanagementService } from '../logmanagement/logmanagement.service';

@Component({
  selector: 'app-product-status-dashboard',
  templateUrl: './product-status-dashboard.component.html',
  styleUrl: './product-status-dashboard.component.scss',
})
export class ProductStatusDashboardComponent {
  productStatusData: any[] = [];
  loading: boolean = true;
  email: any;
  selectedStatus: string | null = null;
  filteredData: any[] = [];
  totalRecords: number = 0;
  statusOptions = [
    { label: 'Live', value: 'Live' },
    { label: 'Review', value: 'Review' },
    { label: 'Parked', value: 'Parked' },
    // { label: 'Ready to Live', value: 'Ready to Live' },
    { label: 'Discontinued', value: 'Discontinued' }
  ];
  displayDialog: boolean = false;
  // dialogMode: 'view' | 'add' | 'edit' = 'view';
  dialogMode: 'view' | 'add' | 'edit' | 'statusChange';
  dialogHeader: string = '';
  selectedComment: string = '';
  selectedRow: any = null;
  targetStatus: any;
  ROADropdownOptions: any[] = [];
  selectedROA: string | null = null;

  constructor(private logmanagementservice: LogmanagementService, private productService: ProductStatusDashboardService, private toastService: ToastMessageService,) { }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    this.selectedStatus = 'Live';
    this.selectedROA = 'ALL';
    this.getRoa();
    this.loadProductStatus(this.email, this.selectedStatus, this.selectedROA);
  }

  openStatusChangeDialog(row: any, targetStatus: string): void {
    this.dialogMode = 'statusChange';
    this.dialogHeader = `Add Reason for Moving to ${targetStatus}`;
    this.selectedRow = row;
    this.targetStatus = targetStatus;
    if (typeof row['status_change_comment'] === 'object') {
      this.selectedComment = row['status_change_comment'].product_comment || '';
    } else {
      this.selectedComment = row['status_change_comment'] || '';
    }
    this.displayDialog = true;
  }


  openDialog(mode: 'view' | 'add' | 'edit', row: any): void {
    this.dialogMode = mode;
    this.selectedRow = row;

    // Check if row already has a comment object or string
    if (typeof row['status_change_comment'] === 'object') {
      this.selectedComment = row['status_change_comment'].product_comment || '';
    } else {
      this.selectedComment = row['status_change_comment'] || '';
    }

    if (mode === 'view') {
      this.dialogHeader = 'View Comment';
    } else if (mode === 'add') {
      this.dialogHeader = 'Add Comment';
      this.selectedComment = ''; // Start fresh
    } else if (mode === 'edit') {
      this.dialogHeader = 'Edit Comment';
    }

    this.displayDialog = true;
  }

  // saveComment(): void {
  //   if (!this.selectedComment || !this.selectedRow) {
  //     return;
  //   }

  //   const payload = {
  //     product_details: {
  //       "NDA number": this.selectedRow["NDA number"],
  //       "Brand Name/Proprietary Name": this.selectedRow["Brand Name/Proprietary Name"],
  //       "Route of Administration": this.selectedRow["Route of Administration"],
  //       "Dosage forms": this.selectedRow["Dosage forms"],
  //       "Nature of Dosage form": this.selectedRow["Nature of Dosage form"]
  //     },
  //     comment: this.selectedComment,
  //     commented_by: this.email // Replace with actual logged-in user
  //   };

  //   this.productService.UpdateProductComment(payload).subscribe({
  //     next: (res) => {
  //       this.selectedRow['status_change_comment'] = {
  //         text: this.selectedComment,
  //         commented_by: 'currentUser@example.com',
  //         commented_at: new Date().toISOString()
  //       };
  //       // this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
  //       this.displayDialog = false;
  //     },
  //     error: (err) => {
  //       // this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to save comment' });
  //     }
  //   });
  // }

  saveComment(): void {
    if (!this.selectedComment || !this.selectedRow) {
      return;
    }

    if (!/[a-zA-Z]/.test(this.selectedComment)) {
      this.toastService.error("Comment must contain letters.");
      return;
    }

    const commentPayload = {
      product_details: {
        "NDA number": this.selectedRow["NDA number"],
        "Brand Name/Proprietary Name": this.selectedRow["Brand Name/Proprietary Name"],
        "Route of Administration": this.selectedRow["Route of Administration"],
        "Dosage forms": this.selectedRow["Dosage forms"],
        "Nature of Dosage form": this.selectedRow["Nature of Dosage form"]
      },
      comment: this.selectedComment,
      commented_by: this.email
    };

    this.productService.UpdateProductComment(commentPayload).subscribe({
      next: (res) => {
        this.selectedRow['status_change_comment'] = {
          product_comment: this.selectedComment,
          commented_by: this.email,
          commented_at: new Date().toISOString()
        };

        this.toastService.success(res.message || 'Comment saved successfully.');

        if (this.dialogMode === 'statusChange' && this.targetStatus) {
          this.updateProductStatus(this.selectedRow, this.targetStatus, true);
        }

        this.displayDialog = false;
      },
      error: () => {
        this.toastService.error('Failed to save comment');
      }
    });
  }


  onStatusChange(): void {
    this.loadProductStatus(this.email, this.selectedStatus, this.selectedROA);
  }

  loadProductStatus(email: string, status: string | null, selectedROA): void {
    this.loading = true;

    const payload = {
      email: email,
      product_status: status || '', // send empty string if no filter selected
      roa: this.selectedROA
    };

    this.productService.getProductStatus(payload).subscribe({
      next: (res) => {
        this.productStatusData = res.data || [];
        this.filteredData = [...this.productStatusData];  // for filtering
        this.totalRecords = res.total_records || this.productStatusData.length;
        this.loading = false;
      },
      error: (err) => {
        console.error("Error fetching product status", err);
        this.loading = false;
      }
    });
  }

  toggleMoveToReview(row: any) {
    let targetStatus = row.moveToReview ? 'Review' : 'Parked';

    const payload = {
      product_details: {
        "NDA number": row["NDA number"],
        "Brand Name/Proprietary Name": row["Brand Name/Proprietary Name"],
        "Route of Administration": row["Route of Administration"],
        "Dosage forms": row["Dosage forms"],
        "Nature of Dosage form": row["Nature of Dosage form"]
      },
      product_status: targetStatus,
      selected_status: this.selectedStatus
    };

    this.productService.UpdateProductStatus(payload).subscribe({
      next: (res) => {
        this.toastService.success(res.message || 'Status updated successfully.');
        this.loadProductStatus(this.email, this.selectedStatus, this.selectedROA);
      },
      error: (err) => {
        this.toastService.error(err?.error?.message || 'Failed to update status.');
      }
    });
  }

  // updateProductStatus(row: any, targetStatus: string): void {
  //   const payload = {
  //     product_details: {
  //       "NDA number": row["NDA number"],
  //       "Brand Name/Proprietary Name": row["Brand Name/Proprietary Name"],
  //       "Route of Administration": row["Route of Administration"],
  //       "Dosage forms": row["Dosage forms"],
  //       "Nature of Dosage form": row["Nature of Dosage form"]
  //     },
  //     product_status: targetStatus,
  //     selected_status: this.selectedStatus
  //   };

  //   this.productService.UpdateProductStatus(payload).subscribe({
  //     next: (res) => {
  //       this.toastService.success(res.message || 'Product updated successfully.');
  //       this.loadProductStatus(this.email, this.selectedStatus);
  //     },
  //     error: (err) => {
  //       const errorMsg = err?.error?.message || 'Failed to update product status. Please try again.';
  //       this.toastService.error(errorMsg);
  //     }
  //   });
  // }

  getRoa() {
    this.logmanagementservice.getUniqueRoa().subscribe(
      (response) => {
        this.ROADropdownOptions = response["data"].map((roa: string) => ({
          label: roa,
          value: roa
        }));
        this.selectedROA = "ALL";
      },
      (error) => {
        console.error('Error fetching data', error);
      }
    );
  }

  onRoaChange(): void {
    this.loadProductStatus(this.email, this.selectedStatus, this.selectedROA);
  }


  updateProductStatus(row: any, targetStatus: string, fromDialog: boolean = false): void {
    if (!fromDialog) {
      // If not coming from dialog, open the dialog instead
      this.openStatusChangeDialog(row, targetStatus);
      return;
    }

    const payload = {
      product_details: {
        "NDA number": row["NDA number"],
        "Brand Name/Proprietary Name": row["Brand Name/Proprietary Name"],
        "Route of Administration": row["Route of Administration"],
        "Dosage forms": row["Dosage forms"],
        "Nature of Dosage form": row["Nature of Dosage form"]
      },
      product_status: targetStatus,
      selected_status: this.selectedStatus
    };

    this.productService.UpdateProductStatus(payload).subscribe({
      next: (res) => {
        this.toastService.success(res.message || 'Product updated successfully.');
        this.loadProductStatus(this.email, this.selectedStatus, this.selectedROA);
      },
      error: (err) => {
        const errorMsg = err?.error?.message || 'Failed to update product status. Please try again.';
        this.toastService.error(errorMsg);
      }
    });
  }

}
